<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Initial Production</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">

    <table>
      <caption>Initial Production</caption>
      <thead>
        <tr>
          <th>Amount of initial production per day</th>
        </tr>

      </thead>

      <tbody>

        <tr>
          <td>
            <p>Natural:</p>
            @if (fieldHasNotes('completionInfo|naturalGas') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|naturalGas'" [notes]="getFilteredNotes('initialProd|naturalGas')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="naturalGas" />

            <p>Gas (MCF)</p>
            @if (fieldHasNotes('completionInfo|naturalOil') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|naturalOil'" [notes]="getFilteredNotes('initialProd|naturalOil')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="naturalOil" />

            <p>Oil (Bbls) </p>
            @if (fieldHasNotes('completionInfo|naturalBrine') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|naturalBrine'" [notes]="getFilteredNotes('initialProd|naturalBrine')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="naturalBrine" />

            <p>Brine (Bbls) </p>
          </td>

          <td>

            <p>After Treatment:</p>
            @if (fieldHasNotes('completionInfo|afterTreatGas') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|afterTreatGas'" [notes]="getFilteredNotes('initialProd|afterTreatGas')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="afterTreatGas" />


            <p>Gas (MCF) </p>
            @if (fieldHasNotes('completionInfo|afterTreatOil') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|afterTreatOil'" [notes]="getFilteredNotes('initialProd|afterTreatOil')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="afterTreatOil" />


            <p>Oil (Bbls) </p>
            @if (fieldHasNotes('completionInfo|afterBrine') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|afterBrine'" [notes]="getFilteredNotes('initialProd|afterBrine')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="afterBrine" />

            <p>Brine (Bbls) </p>
          </td>

          <td>
            <p>SERC Data:</p>
            @if (fieldHasNotes('completionInfo|sercTanks') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|sercTanks'" [notes]="getFilteredNotes('initialProd|sercTanks')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="sercTanks" />

            <p>Number of Tanks</p>
            @if (fieldHasNotes('completionInfo|sercStorage') || reviewStates?.includes(applicationState)) {
              <span class="padding-left">
                <view-notes [fieldName]="'initialProd|sercStorage'" [notes]="getFilteredNotes('initialProd|sercStorage')" (notesRequested)="handleNoteRequested($event)"></view-notes>
              </span>
            }
            <input type="number" formControlName="sercStorage" />

            <p>Maximum Storage Capacity of all Tanks (bbls.)</p>

          </td>
        </tr>
      </tbody>
    </table>


  </div>
</ng-container>

